import QRCode from "react-qr-code";
import Modal from 'react-bootstrap/Modal';
import { useEffect } from 'react'

const QrCode = (props) => {
  const { heading, data } =  props;

  return <><Modal show={data !== undefined }
      onHide={() => props.onHideQrCode(undefined)}
      keyboard={false}
      scrollable={true}>
      <Modal.Title style={{textAlign: "center", fontSize: "1.25rem"}}>{heading}</Modal.Title>
      <Modal.Body className="h6"> 
        <QRCode
          size={256}
          style={{ height: "auto", maxWidth: "60%", marginLeft: "20%" }}
          value={data !== undefined ? data : ""}
          viewBox={`0 0 256 256`}
        />
      </Modal.Body>
      <Modal.Footer>
        <button className='mx-4 btn bg-danger' onClick={() => props.onHideQrCode("")}>Close</button>
      </Modal.Footer>
    </Modal></>
}

export default QrCode;
